import type { FC } from 'react'

import { Plus } from 'lucide-react'
import ButtonLink from '@/components/landing/button-link'
import { Accent, Eyebrow } from '@/components/landing/section-heading'
import { CONTACT_EMAIL, FAQ, LINKS } from '@/constants/kinematic'

const FaqSection: FC = () => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='relative py-24 md:py-32'>
            <div className='mx-auto grid max-w-[1320px] gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-10'>
                <div className='lg:col-span-4'>
                    <Eyebrow index='07' label='Questions' />

                    <h2
                        id='faq-title'
                        className='mt-6 text-balance text-[clamp(2.5rem,5vw,4.25rem)] font-semibold leading-[0.94] tracking-[-0.032em] text-bone stretch-condensed'
                    >
                        Before you <Accent>go live.</Accent>
                    </h2>

                    <p className='mt-6 max-w-sm text-base leading-relaxed text-steel'>
                        Anything else, write to {CONTACT_EMAIL} with your company, markets, currencies and launch timing. The team replies within one business day.
                    </p>

                    <div className='mt-8'>
                        <ButtonLink href={LINKS.email} variant='ghost' size='md'>
                            Write to us
                        </ButtonLink>
                    </div>
                </div>

                <div className='border-t border-white/[0.08] lg:col-span-8'>
                    {FAQ.map((item, index) => (
                        <details key={item.question} open={index === 0} className='group border-b border-white/[0.08]'>
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-6 py-6 text-left text-lg text-bone transition-colors hover:text-white md:text-xl [&::-webkit-details-marker]:hidden'>
                                <span className='flex items-baseline gap-4'>
                                    <span className='font-mono text-[10px] text-steel'>{String(index + 1).padStart(2, '0')}</span>
                                    {item.question}
                                </span>
                                <span className='grid size-9 shrink-0 place-items-center rounded-full border border-white/10 text-bone transition-all duration-300 group-open:rotate-45 group-open:border-ember group-open:bg-ember group-open:text-ink'>
                                    <Plus aria-hidden='true' className='size-4' />
                                </span>
                            </summary>

                            <p className='max-w-[62ch] pb-7 pl-8 text-base leading-relaxed text-steel'>
                                {item.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
